import { render, staticRenderFns } from "./TicketSolicitacaoCandidatos.vue?vue&type=template&id=0349218e&scoped=true&"
import script from "./TicketSolicitacaoCandidatos.vue?vue&type=script&lang=js&"
export * from "./TicketSolicitacaoCandidatos.vue?vue&type=script&lang=js&"
import style0 from "./TicketSolicitacaoCandidatos.vue?vue&type=style&index=0&id=0349218e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349218e",
  null
  
)

export default component.exports